import { render } from "./SpiritOfJapan3.vue?vue&type=template&id=0bebbba8&scoped=true"
import script from "./SpiritOfJapan3.vue?vue&type=script&lang=js"
export * from "./SpiritOfJapan3.vue?vue&type=script&lang=js"

import "./SpiritOfJapan3.scss?vue&type=style&index=0&id=0bebbba8&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bebbba8"]])

export default __exports__